import React from "react"
import { StaticQuery, graphql } from "gatsby"

type Props = {
  render: (data: any) => any
}

function DataQuery({ render }: Props) {
  return (
    <StaticQuery
      query={graphql`
        query AllDataQuery {
          allGraphCmsInterview {
            nodes {
              id
              publishedAt
              createdAt
              title
              page {
                url {
                  ...UrlFields
                }
                image {
                  ...AssetFields
                }
              }
            }
          }
          allGraphCmsContributor {
            nodes {
              id
              name
              age
              avatar {
                ...AssetFields
              }
              occupation
            }
          }
        }
      `}
      render={data => render(data)}
    />
  )
}

export default DataQuery
